import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";
import { subscribeOrganizationBranding } from "../lib/firestore";

const BrandCtx = createContext({ orgLogo: null, orgName: null, orgId: null });

export function BrandProvider({ children }) {
  const { profile } = useAuth();
  const orgId = profile?.organizationId || null;
  const [orgLogo, setOrgLogo] = useState(null);
  const [orgName, setOrgName] = useState(null);

  useEffect(() => {
    if (!orgId) {
      setOrgLogo(null);
      setOrgName(null);
      return;
    }
    return subscribeOrganizationBranding(orgId, (data) => {
      setOrgLogo(data?.organizationLogo || null);
      setOrgName(data?.organizationName || null);
    });
  }, [orgId]);

  return (
    <BrandCtx.Provider value={{ orgLogo, orgName, orgId }}>
      {children}
    </BrandCtx.Provider>
  );
}

export function useBrand() {
  return useContext(BrandCtx);
}
